import { FileDescriptorRead } from "@nens/rana/api-v1";

import { useFileDescriptorQuery } from "@/queries/query-file-descriptors";
import { isTypedDescriptor } from "@/utils/is-descriptor-type";

import type { DisplayPopupInfoItem } from "../components/display-popup-info";

export const layerHasTableMeta = (
  descriptor: FileDescriptorRead | undefined,
  layerName: string
): boolean => {
  const vectorDescriptor = isTypedDescriptor(descriptor, "vector") ? descriptor : undefined;
  const tables = vectorDescriptor?.meta.tables ?? {};
  return Object.values(tables).some((t) => t.layerId === layerName);
};

// True when the items amount to a single vector item with a storage curve graph and nothing else
export function useShowsOnlyGraph(items: DisplayPopupInfoItem[]): boolean {
  const onlyItem = items.length === 1 && items[0].isVector ? items[0] : undefined;
  const { data: descriptor } = useFileDescriptorQuery(onlyItem?.descriptorId);
  return !!onlyItem && layerHasTableMeta(descriptor, onlyItem.layerName);
}
